/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { keysList } from "../funcs/keysList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListKeysResult } from "../models/components/listkeysresult.js";
import {
  ListAPIKeysRequest,
  ListAPIKeysSecurity,
} from "../models/operations/listapikeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ListAPIKeysQueryData = ListKeysResult;

export function prefetchListAPIKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAPIKeysRequest | undefined,
  security?: ListAPIKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListAPIKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListAPIKeysQuery(
  client$: GramCore,
  request?: ListAPIKeysRequest | undefined,
  security?: ListAPIKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListAPIKeysQueryData>;
} {
  return {
    queryKey: queryKeyListAPIKeys({
      agentId: request?.agentId,
      gramSession: request?.gramSession,
    }),
    queryFn: async function listAPIKeysQueryFn(
      ctx,
    ): Promise<ListAPIKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(keysList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListAPIKeys(
  parameters: {
    agentId?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "keys", "list", parameters];
}
